import type { GeoJsonObject } from "geojson";

const GEO_JSON_TYPES = new Set([
  "Feature",
  "FeatureCollection",
  "GeometryCollection",
  "Point",
  "LineString",
  "Polygon",
  "MultiPoint",
  "MultiLineString",
  "MultiPolygon",
]);

const isGeoJsonObject = (value: unknown): value is GeoJsonObject =>
  typeof value === "object" &&
  value !== null &&
  "type" in value &&
  typeof value.type === "string" &&
  GEO_JSON_TYPES.has(value.type);

export async function getOrganizationBoundaryGeoJson(
  boundaryGeoJsonUrl: string,
  signal?: AbortSignal,
): Promise<GeoJsonObject> {
  const response = await fetch(boundaryGeoJsonUrl, {
    signal,
    headers: { Accept: "application/geo+json, application/json" },
  });

  if (!response.ok) {
    throw new Error(`Failed to load organization boundary: ${response.status}`);
  }

  const data: unknown = await response.json();
  if (!isGeoJsonObject(data)) {
    throw new Error("Organization boundary is not valid GeoJSON");
  }

  return data;
}
